"use client";

import { WagmiProvider, createConfig, http } from "wagmi";
import { base } from "wagmi/chains";
import { injected, coinbaseWallet } from "wagmi/connectors";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";


export const wagmiConfig = createConfig({
  ssr: true,
  chains: [base],
  connectors: [
    injected({ target: "metaMask" }),
    coinbaseWallet({
      appName: "ReloadPi",
      preference: "eoaOnly",
    }),
  ],
  transports: {
    [base.id]: http("https://mainnet.base.org"),
  },
});


export default function AppWagmiProvider({ children }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
}
